<template>
  <b-sidebar id="sidebar-aside" title="Sidebar" shadow right>
    <b-tabs v-model="tabIndex" :key="'sidebar-' + tabIndex">
      <b-tab @click="setTab('search')" >
        <template slot="title">
          <b-icon icon='search' v-b-tooltip.hover.lefttop title="Busqueda avanzada del sistema"></b-icon>
        </template>

        <b-list-group class="list-group-accent">
          <b-list-group-item class="aside-search-container">
            <b-input-group>
              <b-form-input v-model="filter.name" 
                            size="sm"
                            v-on:keyup.enter.native="getFilterByName()" 
                            v-b-tooltip.hover.centerbottom title="Escriba su Búsqueda">
              </b-form-input>

              <b-input-group-append>
                <b-button variant="outline-primary" 
                          size="sm" 
                          @click="getFilterByName()" 
                          v-b-tooltip.hover.centerbottom 
                          title="Filtre su Búsqueda">
                  <b-icon icon="funnel-fill"></b-icon>
                </b-button>      
              </b-input-group-append>
            </b-input-group>
          </b-list-group-item>

          <div v-if="status && !items.customers.length && !items.staff.length && !items.suppliers.length" class="p-3 text-center font-weight-bold">
            <b-alert show variant="warning">No se encontró resultados</b-alert>
          </div>
          <div v-if="!status && !items.customers.length && !items.staff.length && !items.suppliers.length" class="p-3 text-center font-weight-bold">
            <b-alert show variant="info">El filtro buscará entre los clientes, proveedores y staff</b-alert>
          </div>

          <!-- STAFF -->
          <b-list-group-item v-if="items.staff.length" class="search-section-title list-group-item-accent-secondary bg-light font-weight-bold text-muted text-uppercase small p-2">
            Staff
          </b-list-group-item>
          <div v-if="items.staff.length">
            <b-list-group-item class="access-direct-select" 
                             v-for="value in items.staff" 
                             v-bind:key="value.id" 
                             @click="goStaff(value)">             
            
              
                <b-avatar :src="value.image"
                          v-if="value.image">
                </b-avatar>
                <b-avatar v-else                                                        
                          variant="dark">
                </b-avatar>     
                <b-icon icon="blank"></b-icon>
                <b>{{value.name}}</b>                   
              
            </b-list-group-item>  
          </div>   
          
          <!-- CLIENTES -->
          <b-list-group-item v-if="items.customers.length" class="search-section-title list-group-item-accent-secondary bg-light font-weight-bold text-muted text-uppercase small p-2">
            Clientes
          </b-list-group-item>
          <div v-if="items.customers.length">
            <b-list-group-item class="access-direct-select" 
                             v-for="value in items.customers" 
                             v-bind:key="value.id" 
                             @click="goCustomers(value)">             
            
              
                <b-avatar :src="value.image"
                          v-if="value.image">
                </b-avatar>
                <b-avatar v-else         
                          icon="building"                                    
                          variant="dark">
                </b-avatar>     
                <b-icon icon="blank"></b-icon>
                <b>{{value.name}}</b>                   
              
            </b-list-group-item>  
          </div>   

          <!-- PROVEEDORES -->
          <b-list-group-item v-if="items.suppliers.length" class="search-section-title list-group-item-accent-secondary bg-light font-weight-bold text-muted text-uppercase small p-2">
            Proveedores
          </b-list-group-item>
          <div v-if="items.suppliers.length">
            <b-list-group-item class="access-direct-select" 
                             v-for="value in items.suppliers" 
                             v-bind:key="value.id" 
                             @click="goSuppliers(value)">             
                          
                <b-avatar :src="value.image"
                          v-if="value.image">
                </b-avatar>
                <b-avatar v-else         
                          icon="building"                                    
                          variant="dark">
                </b-avatar>     
                <b-icon icon="blank"></b-icon>
                <b>{{value.name}}</b>                   
              
            </b-list-group-item>  
          </div>   

        </b-list-group>

      </b-tab>
      
      <b-tab @click="setTab('printer'); filterReport();">
        <template slot="title">
          <b-icon icon='printer' v-b-tooltip.hover.lefttop title="Últimas impresiones"></b-icon>          
        </template>

        <b-button variant="outline-info" 
                  size="sm" 
                  class="w-100"
                  @click="filterReport()" 
                  v-b-tooltip.hover.centerbottom 
                  title="Actualizar datos">
          <b-icon icon="arrow-repeat"></b-icon> Actualziar
        </b-button>      

        <div class="text-center mt-5" v-if="reports.load"> 
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <div v-else>
          <b-list-group v-if="reports.data.length">    
            <b-list-group-item v-for="element in reports.data" :key="element.id"
                              href="javascript:void(0);"                              
                              class="flex-column align-items-start"
                              @click="sendPrinter(element)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{element.title}}</h5>
                <small>{{moment.duration(-moment().diff(element.date)).humanize(true)}}</small>
              </div>
              
              <div v-if="element.metadata">                    
                <b-badge v-for="(item, index) in element.metadata.split('|')" 
                          :key="index" href="javascript:void(0);" 
                          variant="light"
                          class="ml-1"
                          style="font-size:12px;">
                  {{item}}
                </b-badge>
              </div>              
            </b-list-group-item>        
          </b-list-group>        
          <b-alert v-else show variant="warning" class="m-3 text-center">
            No se encontraron impresiones
          </b-alert>
        </div>
      </b-tab>

      <b-tab v-if="canViewScheduledTasksInfo" @click="setTab('scheduledTasks')">
        <template slot="title">
          <b-icon icon='clock-history' v-b-tooltip.hover.lefttop title="Tareas programadas y jobs"></b-icon>
        </template>

        <b-button variant="outline-info"
                  size="sm"
                  class="w-100"
                  @click="loadScheduledTasksMonitor(true)"
                  v-b-tooltip.hover.centerbottom
                  title="Actualizar datos">
          <b-icon icon="arrow-repeat"></b-icon> Actualizar
        </b-button>

        <div class="text-center mt-5" v-if="scheduledTasks.load">
          <b-spinner label="Spinning"></b-spinner>
        </div>

        <div v-else-if="scheduledTasks.loaded" class="p-2">
          <b-alert show variant="light" class="small text-center mb-2">
            Datos generados: {{formatScheduledTaskDateWithSeconds(scheduledTasks.data.generated_at)}}
          </b-alert>

          <div class="scheduled-accordion" role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-warning" role="tab">
                <b-button block v-b-toggle="'scheduled-in-progress'" variant="light" class="text-left">
                  En curso
                  <b-badge variant="warning" class="float-right">
                    {{scheduledTasks.data.scheduled_tasks.started_without_finish_total}} cron / {{scheduledTasks.data.jobs.pending_total}} jobs
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-in-progress" visible accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div class="scheduled-subsection-title">
                    Cron iniciados sin finalizar
                  </div>
                  <div v-if="scheduledTasks.data.scheduled_tasks.started_without_finish_previous_total"
                       class="scheduled-warning-summary mb-2">
                    <div class="scheduled-warning-summary-count">
                      {{scheduledTasks.data.scheduled_tasks.started_without_finish_previous_total}}
                    </div>
                    <div>
                      <div class="font-weight-bold">Inicio(s) sin finalizar de días anteriores</div>
                      <small>Revisar porque ya no corresponde tratarlos como procesos en curso normales.</small>
                    </div>
                  </div>
                  <b-list-group v-if="scheduledTasks.data.scheduled_tasks.started_without_finish_today.length">
                    <b-list-group-item v-for="(element, index) in scheduledTasks.data.scheduled_tasks.started_without_finish_today"
                                      :key="'started-without-finish-' + index"
                                      class="flex-column align-items-start">
                      <div class="d-flex w-100 justify-content-between">
                        <b>{{element.task || 'Sin tarea'}}</b>
                        <b-badge variant="warning">{{element.total}} inicio(s)</b-badge>
                      </div>
                      <div class="small text-muted">
                        {{element.module || 'Sin módulo'}} · Último inicio: {{formatScheduledTaskDate(element.last_date)}}
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay tareas en curso sin finalizar hoy
                  </b-alert>

                  <div class="scheduled-subsection-title mt-3">
                    Jobs en cola
                  </div>
                  <b-list-group v-if="scheduledTasks.data.jobs.pending_groups.length">
                    <b-list-group-item v-for="(element, index) in scheduledTasks.data.jobs.pending_groups"
                                      :key="'pending-job-' + index"
                                      class="flex-column align-items-start">
                      <div class="scheduled-task-item">
                        <div class="scheduled-task-title">{{element.job || 'Job no identificado'}}</div>
                        <div class="scheduled-task-meta"
                             v-b-tooltip.hover
                             :title="formatScheduledTaskDate(element.oldest_created_at)">
                          Cola: {{element.queue}} · Más viejo: {{formatScheduledTaskDateHuman(element.oldest_created_at)}}
                        </div>
                        <div class="scheduled-task-meta"
                             v-if="element.last_reserved_at"
                             v-b-tooltip.hover
                             :title="formatScheduledTaskDate(element.last_reserved_at)">
                          Último tomado por worker: {{formatScheduledTaskDateHuman(element.last_reserved_at)}}
                        </div>
                        <div class="scheduled-task-stats scheduled-task-stats-info">
                          <span>{{element.available_total}} disponibles</span>
                          <span>{{element.reserved_total}} tomados</span>
                          <span>{{element.total}} total</span>
                        </div>
                        <div class="scheduled-job-attempts" v-if="element.max_attempts > 0">
                          Máximo de intentos registrados: {{element.max_attempts}}
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay jobs pendientes en cola
                  </b-alert>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-info" role="tab">
                <b-button block v-b-toggle="'scheduled-upcoming'" variant="light" class="text-left">
                  Próximas 24 hs
                  <b-badge variant="info" class="float-right">
                    {{scheduledTasks.data.scheduled_tasks.upcoming.length}}
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-upcoming" accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div v-if="scheduledUpcomingRecurring.length" class="mb-2">
                    <div class="scheduled-subsection-title">
                      Alta frecuencia
                    </div>
                    <b-list-group flush>
                      <b-list-group-item v-for="(element, index) in scheduledUpcomingRecurring"
                                        :key="'upcoming-recurring-' + index"
                                        class="flex-column align-items-start scheduled-upcoming-item">
                        <div class="d-flex w-100 justify-content-between align-items-start">
                          <b class="scheduled-task-title scheduled-upcoming-title">{{element.name || 'Sin tarea'}}</b>
                          <b-badge variant="info">{{frequencyLabel(element)}}</b-badge>
                        </div>
                        <div class="scheduled-task-meta">
                          {{element.source}} · {{element.expression}}
                        </div>
                        <div class="scheduled-task-meta mb-0">
                          Próxima: {{formatScheduledTaskDate(element.date)}} · {{element.runs_in_day}} ejecuciones en 24 hs
                        </div>
                      </b-list-group-item>
                    </b-list-group>
                  </div>

                  <div v-if="scheduledUpcomingGroups.length">
                    <b-card v-for="(group, groupIndex) in scheduledUpcomingGroups"
                            :key="'upcoming-hour-group-' + groupIndex"
                            no-body
                            class="mb-2 scheduled-upcoming-group">
                      <b-card-header class="scheduled-upcoming-group-header py-2" header-tag="header" role="tab">
                        <b-button block
                                  v-b-toggle="'scheduled-upcoming-hour-' + groupIndex"
                                  variant="light"
                                  class="scheduled-upcoming-button text-left">
                          <div>
                            <div class="font-weight-bold">{{group.label}}</div>
                            <small class="text-muted">{{group.items.length}} ejecución(es)</small>
                          </div>
                          <b-badge variant="info">{{group.hour}}</b-badge>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'scheduled-upcoming-hour-' + groupIndex"
                                  accordion="scheduled-upcoming-hours"
                                  role="tabpanel">
                        <b-list-group flush>
                          <b-list-group-item v-for="(element, index) in group.items"
                                            :key="'upcoming-task-' + groupIndex + '-' + index"
                                            class="flex-column align-items-start scheduled-upcoming-item">
                            <div class="d-flex w-100 justify-content-between align-items-start">
                              <b class="scheduled-task-title scheduled-upcoming-title">{{element.name || 'Sin tarea'}}</b>
                              <small class="text-info font-weight-bold scheduled-upcoming-time">{{formatScheduledTaskDate(element.date)}}</small>
                            </div>
                            <div class="scheduled-task-meta">
                              {{element.source}} · {{element.expression}}
                            </div>
                            <div class="scheduled-task-meta mb-0">
                              Próxima ejecución agrupada en esta hora
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-if="!scheduledUpcomingRecurring.length && !scheduledUpcomingGroups.length" show variant="warning" class="text-center">
                    No se detectaron próximas ejecuciones
                  </b-alert>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-danger" role="tab">
                <b-button block v-b-toggle="'scheduled-failed'" variant="light" class="text-left">
                  Fallidas
                  <b-badge variant="danger" class="float-right">
                    {{scheduledTasks.data.failed_jobs.total + scheduledTasks.data.scheduled_tasks.errors.total + (isModuleVentasActive ? scheduledTasks.data.sales_sync_errors.unique_total : 0) + (isModulePedidosActive ? scheduledTasks.data.orders_sync_errors.unique_total : 0)}}
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-failed" accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div class="scheduled-subsection-title">
                    Cron con error
                  </div>
                  <div v-if="scheduledTasks.data.scheduled_tasks.errors.groups.length">
                    <b-card v-for="(element, index) in scheduledTasks.data.scheduled_tasks.errors.groups"
                            :key="'scheduled-error-group-' + index"
                            no-body
                            class="mb-2 scheduled-error-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-error-header" role="tab">
                        <b-button block
                                  v-b-toggle="'scheduled-error-group-' + index"
                                  variant="light"
                                  class="text-left scheduled-error-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">{{element.task || 'Sin tarea'}}</span>
                            <b-icon icon="chevron-down" class="scheduled-accordion-icon"></b-icon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{element.today_total}} hoy / {{element.total}} total
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'scheduled-error-group-' + index"
                                  accordion="scheduled-error-groups"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-item">
                            <div class="scheduled-task-title"
                                 v-if="element.task">
                              {{element.task}}
                            </div>
                            <div class="scheduled-task-meta">
                              {{element.category}} · {{element.module || 'Sin módulo'}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-if="element.observations">
                              {{element.observations}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-b-tooltip.hover
                                 :title="formatScheduledTaskDate(element.last_date)">
                              Última aparición: {{formatScheduledTaskDateHuman(element.last_date)}}
                            </div>
                            <div class="scheduled-task-stats scheduled-task-stats-danger">
                              <span>{{element.today_total}} hoy</span>
                              <span>{{element.total}} total</span>
                            </div>
                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de cron registrados
                  </b-alert>
                  <div class="scheduled-maintenance-actions"
                       v-if="scheduledTasks.data.scheduled_tasks.errors.total">
                    <b-button v-if="scheduledTasks.data.scheduled_tasks.errors.old_total"
                              size="sm"
                              variant="outline-secondary"
                              @click="confirmCleanupScheduledTasks('Error', 'older_than_year')">
                      Limpiar fallidas anteriores a 365 días
                    </b-button>
                    <b-button v-else
                              size="sm"
                              variant="outline-danger"
                              @click="confirmCleanupScheduledTasks('Error', 'all')">
                      Borrar todas las fallidas
                    </b-button>
                  </div>

                  <div class="scheduled-subsection-title mt-3">
                    Jobs fallidos
                  </div>
                  <div v-if="scheduledTasks.data.failed_jobs.groups.length">
                    <b-card v-for="(element, index) in scheduledTasks.data.failed_jobs.groups"
                            :key="'failed-group-' + index"
                            no-body
                            class="mb-2 scheduled-error-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-error-header" role="tab">
                        <b-button block
                                  v-b-toggle="'failed-job-group-' + index"
                                  variant="light"
                                  class="text-left scheduled-error-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">
                              <span class="scheduled-accordion-title">{{getFailedJobTitle(element)}}</span>
                            </span>
                            <b-icon icon="chevron-down" class="scheduled-accordion-icon"></b-icon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{element.today_total}} hoy / {{element.total}} total
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'failed-job-group-' + index"
                                  accordion="failed-job-groups"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-item">
                            <div class="scheduled-task-title">
                              {{element.error_message || 'Job fallido'}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-b-tooltip.hover
                                 :title="formatScheduledTaskDate(element.last_failed_at)">
                              {{element.category}} · Cola: {{element.queue}}
                            </div>
                            <div class="scheduled-task-meta"
                                 v-b-tooltip.hover
                                 :title="formatScheduledTaskDate(element.last_failed_at)">
                              Última aparición: {{formatScheduledTaskDateHuman(element.last_failed_at)}}
                            </div>
                            <div class="scheduled-task-stats scheduled-task-stats-danger">
                              <span>{{element.today_total}} hoy</span>
                              <span>{{element.total}} total</span>
                            </div>
                            <div class="scheduled-group-actions">
                              <b-button size="sm"
                                        variant="outline-secondary"
                                        @click="confirmCleanupFailedJobs(element)">
                                Dejar solo última semana
                              </b-button>
                            </div>
                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de jobs registrados
                  </b-alert>

                  <template v-if="isModuleVentasActive">
                  <div class="scheduled-subsection-title mt-3">
                    Errores de facturación
                  </div>
                  <div v-if="scheduledTasks.data.sales_sync_errors.groups.length">
                    <b-card v-for="(staffGroup, staffIndex) in scheduledTasks.data.sales_sync_errors.groups"
                            :key="'sales-sync-error-staff-' + staffIndex"
                            no-body
                            class="mb-2 scheduled-sales-sync-staff-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-sales-sync-staff-header" role="tab">
                        <b-button block
                                  v-b-toggle="'sales-sync-error-staff-' + staffIndex"
                                  variant="light"
                                  class="text-left scheduled-sales-sync-staff-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">{{staffGroup.staff_name || 'Sin usuario'}}</span>
                            <b-icon icon="chevron-down" class="scheduled-accordion-icon"></b-icon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{staffGroup.unique_total}} comprobante(s)
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'sales-sync-error-staff-' + staffIndex"
                                  accordion="sales-sync-error-staff"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-meta"
                               v-b-tooltip.hover
                               :title="formatScheduledTaskDate(staffGroup.last_occurred_at)">
                            Última aparición: {{formatScheduledTaskDateHuman(staffGroup.last_occurred_at)}}
                          </div>
                          <b-list-group>
                            <b-list-group-item v-for="(element, errorIndex) in staffGroup.errors"
                                              :key="'sales-sync-error-' + staffIndex + '-' + errorIndex"
                                              class="flex-column align-items-start scheduled-sales-sync-error-item">
                              <div class="scheduled-task-item">
                                <div class="scheduled-task-title">{{element.error_message || 'Error sin detalle'}}</div>
                                <div class="scheduled-task-meta">
                                  {{element.category}} · Último intento: {{element.max_attempt || 0}}
                                </div>
                                <div class="scheduled-task-meta"
                                     v-b-tooltip.hover
                                     :title="formatScheduledTaskDate(element.last_occurred_at)">
                                  Última aparición: {{formatScheduledTaskDateHuman(element.last_occurred_at)}}
                                </div>
                                <div class="scheduled-task-stats scheduled-task-stats-danger">
                                  <span>{{element.today_unique_total}} hoy</span>
                                  <span>{{element.unique_total}} comp.</span>
                                </div>
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de facturación registrados
                  </b-alert>
                  </template>

                  <template v-if="isModulePedidosActive">
                  <div class="scheduled-subsection-title mt-3">
                    Errores de pedidos móviles
                  </div>
                  <div v-if="scheduledTasks.data.orders_sync_errors.groups.length">
                    <b-card v-for="(sellerGroup, sellerIndex) in scheduledTasks.data.orders_sync_errors.groups"
                            :key="'orders-sync-error-seller-' + sellerIndex"
                            no-body
                            class="mb-2 scheduled-sales-sync-staff-group">
                      <b-card-header header-tag="header" class="p-1 scheduled-sales-sync-staff-header" role="tab">
                        <b-button block
                                  v-b-toggle="'orders-sync-error-seller-' + sellerIndex"
                                  variant="light"
                                  class="text-left scheduled-sales-sync-staff-button">
                          <div class="scheduled-accordion-main">
                            <span class="scheduled-accordion-label">{{sellerGroup.seller_name || 'Sin vendedor'}}</span>
                            <b-icon icon="chevron-down" class="scheduled-accordion-icon"></b-icon>
                          </div>
                          <div class="scheduled-accordion-summary">
                            {{sellerGroup.unique_total}} pedido(s)
                          </div>
                        </b-button>
                      </b-card-header>
                      <b-collapse :id="'orders-sync-error-seller-' + sellerIndex"
                                  accordion="orders-sync-error-seller"
                                  role="tabpanel">
                        <b-card-body class="p-2">
                          <div class="scheduled-task-meta"
                               v-b-tooltip.hover
                               :title="formatScheduledTaskDate(sellerGroup.last_occurred_at)">
                            Última aparición: {{formatScheduledTaskDateHuman(sellerGroup.last_occurred_at)}}
                          </div>
                          <b-list-group>
                            <b-list-group-item v-for="(element, errorIndex) in sellerGroup.errors"
                                              :key="'orders-sync-error-' + sellerIndex + '-' + errorIndex"
                                              class="flex-column align-items-start scheduled-sales-sync-error-item">
                              <div class="scheduled-task-item">
                                <div class="scheduled-task-title">{{element.error_message || 'Error sin detalle'}}</div>
                                <div class="scheduled-task-meta">
                                  {{element.category}} · Último intento: {{element.max_attempt || 0}}
                                </div>
                                <div class="scheduled-task-meta"
                                     v-b-tooltip.hover
                                     :title="formatScheduledTaskDate(element.last_occurred_at)">
                                  Última aparición: {{formatScheduledTaskDateHuman(element.last_occurred_at)}}
                                </div>
                                <div class="scheduled-task-stats scheduled-task-stats-danger">
                                  <span>{{element.today_unique_total}} hoy</span>
                                  <span>{{element.unique_total}} pedido(s)</span>
                                </div>
                              </div>
                            </b-list-group-item>
                          </b-list-group>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay errores de pedidos móviles registrados
                  </b-alert>
                  </template>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1 scheduled-section-title-success" role="tab">
                <b-button block v-b-toggle="'scheduled-executed'" variant="light" class="text-left">
                  Ejecutadas
                  <b-badge variant="success" class="float-right">
                    {{scheduledTasks.data.scheduled_tasks.executed_groups_by_module.length}}
                  </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse id="scheduled-executed" visible accordion="scheduled-tasks-monitor" role="tabpanel">
                <b-card-body>
                  <div v-if="scheduledTasks.data.scheduled_tasks.executed_groups_by_module.length">
                    <div v-for="(moduleGroup, moduleIndex) in scheduledTasks.data.scheduled_tasks.executed_groups_by_module"
                         :key="'executed-module-' + moduleIndex"
                         class="scheduled-module-group">
                      <b-card no-body>
                        <b-card-header header-tag="header" class="p-1 scheduled-module-header" role="tab">
                          <b-button block
                                    v-b-toggle="'scheduled-executed-module-' + moduleIndex"
                                    variant="light"
                                    class="text-left scheduled-module-button">
                            <span>{{moduleGroup.module}}</span>
                            <b-badge variant="success" class="float-right">{{moduleGroup.today_total}} hoy / {{moduleGroup.total}} total</b-badge>
                          </b-button>
                        </b-card-header>
                        <b-collapse :id="'scheduled-executed-module-' + moduleIndex"
                                    accordion="scheduled-executed-modules"
                                    role="tabpanel">
                          <b-card-body class="p-2">
                            <b-list-group>
                              <b-list-group-item v-for="(element, index) in moduleGroup.tasks"
                                                :key="'executed-group-' + moduleIndex + '-' + index"
                                                class="flex-column align-items-start scheduled-executed-item">
                                <div class="scheduled-task-item">
                                  <div class="scheduled-task-title">{{element.task || 'Sin tarea'}}</div>
                                  <div class="scheduled-task-meta"
                                       v-b-tooltip.hover
                                       :title="formatScheduledTaskDate(element.last_date)">
                                    Última: {{formatScheduledTaskDateHuman(element.last_date)}}
                                  </div>
                                  <div class="scheduled-task-stats scheduled-task-stats-success">
                                    <span>{{element.today_total}} hoy</span>
                                    <span>{{element.total}} total</span>
                                  </div>
                                </div>
                              </b-list-group-item>
                            </b-list-group>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                  <b-alert v-else show variant="warning" class="text-center">
                    No hay tareas ejecutadas registradas
                  </b-alert>
                  <div class="scheduled-maintenance-actions"
                       v-if="scheduledTasks.data.scheduled_tasks.executed_total">
                    <b-button v-if="scheduledTasks.data.scheduled_tasks.executed_old_total"
                              size="sm"
                              variant="outline-secondary"
                              @click="confirmCleanupScheduledTasks('Fin', 'older_than_year')">
                      Limpiar ejecutadas anteriores a 365 días
                    </b-button>
                    <b-button v-else-if="scheduledTasks.data.scheduled_tasks.executed_total"
                              size="sm"
                              variant="outline-danger"
                              @click="confirmCleanupScheduledTasks('Fin', 'all')">
                      Borrar todas las ejecutadas
                    </b-button>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <b-alert v-else show variant="info" class="m-3 text-center">
          Ingrese a esta solapa para consultar el estado de tareas y jobs.
        </b-alert>
      </b-tab>
      
    </b-tabs>

    <!--
    ###########################
    ######### PRINTER #########
    ###########################
    -->
    <Printer v-if="crud.print.pdf" 
            :pdf="crud.print.pdf"               
            :key="crud.print.key"/>

  </b-sidebar>
</template>

<script>

import Error from '@/handler/error'
import Helper from '@/handler/helper' 
import serviceAPI from './services'
import Printer from '@/components/inc/printer/printer'
import Storage from '@/handler/storageLocal'
import Session from '@/handler/session'
import Modules from '@/config/modules'

export default {
  name: 'DefaultAside', 
  components: {    
    Printer
  },      
  data: () => {
    return {
      filter: {
        name: ''
      },
      items: {
        customers: [],
        staff: [],
        suppliers: []
      },
      status: false,
      reports: {
        data: [],
        load: false,
      },
      scheduledTasks: {
        data: {
          generated_at: '',
          jobs: {
            pending_total: 0,
            pending_by_queue: [],
            pending_groups: [],
          },
          failed_jobs: {
            total: 0,
            today: 0,
            groups: [],
            recent: [],
          },
          sales_sync_errors: {
            total: 0,
            today: 0,
            unique_total: 0,
            unique_today: 0,
            groups: [],
          },
          orders_sync_errors: {
            total: 0,
            today: 0,
            unique_total: 0,
            unique_today: 0,
            groups: [],
          },
          scheduled_tasks: {
            total: 0,
            started_without_finish_total: 0,
            summary: [],
            completed_today: [],
            started_without_finish_today: [],
            started_without_finish_previous_total: 0,
            executed_total: 0,
            executed_old_total: 0,
            executed_groups: [],
            executed_groups_by_module: [],
            errors: {
              total: 0,
              today: 0,
              old_total: 0,
              groups: [],
            },
            upcoming: [],
            recent: [],
          },
        },
        load: false,
        loaded: false,
      },
      crud: {
        print: {
          pdf: '',            
          key: 0,
        }  
      },
      tabIndex: 0,
      modulesActive: [],
    }
  },
  mounted() {
    this.restoreTabStorage()
    this.modulesActive = Session.getSession().auth.user.permissions.modules
  },
  computed: {
    // Los errores de facturación/pedidos móviles solo tienen sentido si el
    // módulo correspondiente (Ventas/Pedidos) está activado para la cuenta —
    // sin esto, un cliente sin ese módulo veía igual la sección (siempre en
    // "sin errores", pero visible y ocupando lugar).
    isModuleVentasActive() {
      return this.modulesActive.some(element => element.id == Modules.VENTAS)
    },
    isModulePedidosActive() {
      return this.modulesActive.some(element => element.id == Modules.PEDIDOS)
    },
    canViewScheduledTasksInfo() {
      let session = Session.getSession()
      if(!session || !session.auth || !session.auth.user) {
        return false
      }

      let currentStaff = session.auth.user.current_staff

      return !!(currentStaff && currentStaff.view_scheduled_tasks_info)
    },
    // Las tareas de alta frecuencia (cada minuto, cada 30 min, etc.) vienen
    // resumidas en una sola entrada con recurring=true — se muestran aparte
    // para que no tapen a las de baja frecuencia en los grupos por hora.
    scheduledUpcomingRecurring() {
      return this.scheduledTasks.data.scheduled_tasks.upcoming.filter(item => item.recurring)
    },
    scheduledUpcomingGroups() {
      return this.groupScheduledTasksByHour(this.scheduledTasks.data.scheduled_tasks.upcoming.filter(item => !item.recurring))
    },
  },
  methods: {
    setTab(reference) {      
      switch (reference) {
        case 'search':
          this.tabIndex = 0   
          break;
        case 'printer':
          this.tabIndex = 1
          break;
        case 'scheduledTasks':
          this.tabIndex = 2
          this.loadScheduledTasksMonitor()
          break;
      }      
      this.saveTabStorage()
    },

    getFilterByName() {
      if (this.filter.name.length < 3) {
        this.$awn.alert("Ingrese al menos 3 caracteres para realizar el filtro");      
        return false
      }

      this.getCustomersByName()
      this.getStaffByName()
      this.getSuppliersByName()      
    },        

    getCustomersByName() {
      let loader = this.$loading.show()
      var result = serviceAPI.filterCustomersByName(this.filter)

      result.then((response) => {
        var data = response.data
        this.items.customers = data
        this.status = true
        loader.hide()
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        loader.hide()
      });
    },
    getStaffByName() {
      let loader = this.$loading.show()
      var result = serviceAPI.filterStaffByName(this.filter)

      result.then((response) => {
        var data = response.data
        this.items.staff = data
        this.status = true
        loader.hide()
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        loader.hide()
      });
    },
    getSuppliersByName() {
      let loader = this.$loading.show()
      var result = serviceAPI.filterSuppliersByName(this.filter)

      result.then((response) => {
        var data = response.data
        this.items.suppliers = data
        this.status = true
        loader.hide()
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        loader.hide()
      });
    },

    goCustomers(item) {
      this.$router.push({ name: 'CustomerViewStaff', params: {customersID: item.id} })
    },        
    goStaff(item) {
      this.$router.push({ name: 'StaffViewStaff', params: {staffID: item.id} })
    },        
    goSuppliers(item) {
      this.$router.push({ name: 'SuppliersViewStaff', params: {suppliersID: item.id} })
    },

    filterReport() {      
      this.reports.load = true
      var result = serviceAPI.getFilterReportLog({
        staff: { code: Helper.getStaffId() }
      }, 1)

      result.then((response) => {
        this.reports.load = false
        this.reports.data = response.data.data        
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.reports.load = false
      });      
    },
    sendPrinter(item) {
      this.crud.print.key = Math.random()
      this.crud.print.pdf = item.url
    },    
    loadScheduledTasksMonitor(force) {
      if(this.scheduledTasks.loaded && !force) {
        return
      }

      this.scheduledTasks.load = true
      var result = serviceAPI.getScheduledTasksMonitor()

      result.then((response) => {
        // Backend anterior sin el monitor de pedidos móviles: default vacío
        // para que el template no falle.
        if (!response.data.orders_sync_errors) {
          response.data.orders_sync_errors = { total: 0, today: 0, unique_total: 0, unique_today: 0, groups: [] }
        }
        this.scheduledTasks.data = response.data
        this.scheduledTasks.loaded = true
        this.scheduledTasks.load = false
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.scheduledTasks.load = false
      });
    },
    confirmCleanupScheduledTasks(status, mode) {
      let isExecuted = status == 'Fin'
      let typeText = isExecuted ? 'ejecutadas' : 'fallidas'
      let actionText = mode == 'all'
        ? 'Se eliminarán todas las tareas programadas ' + typeText + '.'
        : 'Se eliminarán solo tareas programadas ' + typeText + ' anteriores a 365 días.'

      this.$bvModal.msgBoxConfirm(actionText + ' No se eliminan jobs, errores de jobs ni logs de instancias. ¿Continuar?', {
        title: 'Limpiar historial de tareas programadas',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Limpiar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value) {
          this.cleanupScheduledTasks(status, mode)
        }
      })
    },
    cleanupScheduledTasks(status, mode) {
      this.scheduledTasks.load = true
      var result = serviceAPI.cleanupScheduledTasksMonitor({
        status: status,
        mode: mode
      })

      result.then((response) => {
        this.$awn.success('Historial limpiado. Registros eliminados: ' + response.data.deleted)
        this.scheduledTasks.loaded = false
        this.loadScheduledTasksMonitor(true)
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.scheduledTasks.load = false
      });
    },
    confirmCleanupFailedJobs(element) {
      this.$bvModal.msgBoxConfirm('Se eliminarán solo errores de este grupo anteriores a 7 días. No se eliminan jobs pendientes, cron ni otros grupos de errores. ¿Continuar?', {
        title: 'Limpiar grupo de jobs fallidos',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Limpiar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value) {
          this.cleanupFailedJobs(element)
        }
      })
    },
    cleanupFailedJobs(element) {
      this.scheduledTasks.load = true
      var result = serviceAPI.cleanupFailedJobsMonitor({
        queue: element.queue,
        error_message: element.raw_error_message || element.error_message
      })

      result.then((response) => {
        this.$awn.success('Grupo de jobs fallidos limpiado. Registros eliminados: ' + response.data.deleted)
        this.scheduledTasks.loaded = false
        this.loadScheduledTasksMonitor(true)
      })
      .catch(error => {
        this.$awn.alert(Error.showError(error));
        this.scheduledTasks.load = false
      });
    },
    getScheduledTaskErrorVariant(category) {
      switch (category) {
        case 'Configuración':
          return 'warning'
        case 'Base de datos':
          return 'danger'
        case 'Conectividad':
          return 'info'
        default:
          return 'secondary'
      }
    },
    getFailedJobTitle(element) {
      let message = element && element.error_message ? element.error_message : ''
      let className = this.extractLastClassName(message)

      if(className) {
        return className
      }

      if(!message) {
        return 'Job fallido'
      }

      let cleanMessage = message.replace(/^Exception:\s*/i, '').trim()

      if(cleanMessage.length > 55) {
        return cleanMessage.substring(0, 55) + '...'
      }

      return cleanMessage
    },
    extractLastClassName(message) {
      let matches = String(message || '').match(/[A-Za-z0-9_]+(?:\\[A-Za-z0-9_]+)+/g)

      if(!matches || !matches.length) {
        return ''
      }

      let parts = matches[0].split('\\')

      return parts[parts.length - 1] || ''
    },
    formatScheduledTaskDate(date) {
      if(!date) {
        return ''
      }

      return this.moment(date).format('DD/MM/YY HH:mm')
    },
    frequencyLabel(element) {
      var minutes = element.frequency_minutes

      if (!minutes) return 'Alta frecuencia'
      if (minutes == 1) return 'Cada minuto'
      if (minutes < 60) return 'Cada ' + minutes + ' min'
      if (minutes == 60) return 'Cada hora'

      return 'Cada ' + Math.round(minutes / 60) + ' hs'
    },
    formatScheduledTaskDateWithSeconds(date) {
      if(!date) {
        return ''
      }

      return this.moment(date).format('DD/MM/YY HH:mm:ss')
    },
    formatScheduledTaskDateHuman(date) {
      if(!date) {
        return ''
      }

      return this.moment.duration(-this.moment().diff(date)).humanize(true)
    },
    groupScheduledTasksByHour(items) {
      if(!items || !items.length) {
        return []
      }

      let groups = {}

      items.forEach((item) => {
        let key = this.moment(item.date).format('DD/MM/YY HH:00')

        if(!groups[key]) {
          groups[key] = {
            hour: this.moment(item.date).format('HH:00'),
            label: this.moment(item.date).format('DD/MM/YY HH:00'),
            sortDate: this.moment(item.date).valueOf(),
            items: [],
          }
        }

        groups[key].items.push(item)
      })

      return Object.keys(groups)
        .sort((a, b) => groups[a].sortDate - groups[b].sortDate)
        .map((key) => {
          groups[key].items = groups[key].items.sort((a, b) => this.moment(a.date).valueOf() - this.moment(b.date).valueOf())
          return groups[key]
        })
    },

    // TAB SAVE
    saveTabStorage() {
      Storage.setValue('tab_container_aside', this.tabIndex)
    },
    restoreTabStorage() {
      if(Storage.getValue('tab_container_aside')) {
        this.tabIndex = parseInt(Storage.getValue('tab_container_aside'))
      }

      if(this.tabIndex == 2 && !this.canViewScheduledTasksInfo) {
        this.tabIndex = 0
      }

      if(this.tabIndex == 1) {
        this.filterReport()
      }

      if(this.tabIndex == 2 && this.canViewScheduledTasksInfo) {
        this.loadScheduledTasksMonitor()
      }
    },    
  }
}
</script>
<style>
  .title-select {
    padding: 8px;
  }
  .access-direct-select {
    cursor: pointer;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 10px;    
    padding-right: 10px;
    border-bottom-style: solid !important;
    border-bottom-width: 1px !important;
    border-bottom-color: #eaeaea !important;
  }
  .b-sidebar .list-group-item.aside-search-container:hover,
  .b-sidebar .list-group-item.aside-search-container:focus,
  .b-sidebar .list-group-item.aside-search-container.active {
    background-color: #fff !important;
    border-color: #e4e7ea !important;
  }
  .b-sidebar .list-group-item.search-section-title:hover,
  .b-sidebar .list-group-item.search-section-title:focus,
  .b-sidebar .list-group-item.search-section-title.active {
    background-color: #f8f9fa !important;
    border-color: #e4e7ea !important;
    color: #6c757d !important;
  }
  .b-sidebar .access-direct-select:hover,
  .b-sidebar .access-direct-select:focus,
  .b-sidebar .access-direct-select.active {
    background-color: #f4f6f8 !important;
    border-color: #e4e7ea !important;
    color: #2f353a !important;
  }
  .b-sidebar .access-direct-select:hover *,
  .b-sidebar .access-direct-select:focus *,
  .b-sidebar .access-direct-select.active * {
    color: inherit !important;
  }
  .scheduled-section-title {
    border-left: 4px solid #d8dbe0;
    padding-left: 8px;
  }
  .scheduled-section-title-warning {
    border-left-color: #f0ad4e;
  }
  .scheduled-section-title-danger {
    border-left-color: #f86c6b;
  }
  .scheduled-section-title-success {
    border-left-color: #4dbd74;
  }
  .scheduled-section-title-info {
    border-left-color: #20a8d8;
  }
  .scheduled-accordion .card-header {
    border-left-width: 4px;
    border-left-style: solid;
  }
  .scheduled-accordion .btn {
    font-weight: 600;
  }
  .scheduled-accordion .list-group-item:hover,
  .scheduled-accordion .list-group-item:focus {
    background-color: #f4f6f8 !important;
    border-color: #e4e7ea !important;
    color: inherit !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover,
  .b-sidebar .scheduled-accordion .list-group-item:focus,
  .b-sidebar .scheduled-accordion .list-group-item.active {
    background-color: #f4f6f8 !important;
    border-color: #e4e7ea !important;
    color: #2f353a !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover *,
  .b-sidebar .scheduled-accordion .list-group-item:focus *,
  .b-sidebar .scheduled-accordion .list-group-item.active * {
    color: inherit !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover .scheduled-task-stats-success,
  .b-sidebar .scheduled-accordion .list-group-item:focus .scheduled-task-stats-success,
  .b-sidebar .scheduled-accordion .list-group-item.active .scheduled-task-stats-success {
    background-color: #dff3e7 !important;
    color: #1f7a43 !important;
  }
  .b-sidebar .scheduled-accordion .list-group-item:hover .scheduled-task-stats-danger,
  .b-sidebar .scheduled-accordion .list-group-item:focus .scheduled-task-stats-danger,
  .b-sidebar .scheduled-accordion .list-group-item.active .scheduled-task-stats-danger {
    background-color: #f4e4e4 !important;
    color: #7a1515 !important;
  }
  .scheduled-accordion .list-group-item:hover .scheduled-task-title,
  .scheduled-accordion .list-group-item:focus .scheduled-task-title {
    color: #2f353a !important;
  }
  .scheduled-accordion .list-group-item:hover .scheduled-task-meta,
  .scheduled-accordion .list-group-item:focus .scheduled-task-meta {
    color: #536c79 !important;
  }
  .scheduled-accordion .card-body:hover,
  .scheduled-accordion .scheduled-task-item:hover {
    background-color: #f7f9fa !important;
    color: inherit !important;
  }
  .scheduled-task-item {
    min-width: 0;
    width: 100%;
  }
  .scheduled-task-title {
    font-weight: 700;
    line-height: 1.25;
    margin-bottom: 3px;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .scheduled-task-meta {
    color: #73818f;
    font-size: 12px;
    line-height: 1.25;
    margin-bottom: 8px;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .scheduled-upcoming-group {
    border: 1px solid #d7ecf7;
    border-radius: 4px;
    box-shadow: none;
  }
  .scheduled-upcoming-group-header {
    background: #f2fbff;
    border-bottom: 1px solid #d7ecf7;
    padding: 0.5rem 0.5rem !important;
  }
  .scheduled-upcoming-button {
    align-items: center;
    color: #16617a;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 6px 8px;
  }
  .scheduled-upcoming-button:hover,
  .scheduled-upcoming-button:focus {
    background: #e8f5fb;
    color: #104a5d;
    text-decoration: none;
  }
  .scheduled-upcoming-button .badge {
    flex: 0 0 auto;
    line-height: 1.2;
    padding: 5px 7px;
  }
  .scheduled-upcoming-item {
    padding-top: 14px;
    padding-bottom: 14px;
    min-height: 90px;
  }
  .scheduled-upcoming-title {
    padding-right: 8px;
  }
  .scheduled-upcoming-time {
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .scheduled-task-stats {
    align-items: center;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
    font-weight: 700;
    gap: 4px;
    justify-content: space-between;
    padding: 6px 8px;
    width: 100%;
  }
  .scheduled-task-stats span {
    flex: 1 1 58px;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .scheduled-task-stats-success {
    background: #e8f7ef;
    color: #1f7a43;
  }
  .scheduled-task-stats-danger {
    background: #fdeaea;
    color: #9b1c1c;
  }
  .scheduled-task-stats-info {
    background: #eaf6fb;
    color: #16617a;
  }
  .scheduled-subsection-title {
    border-bottom: 1px solid #e4e7ea;
    color: #536c79;
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 8px;
    padding-bottom: 4px;
    text-transform: uppercase;
  }
  .scheduled-job-attempts {
    color: #8a6d3b;
    font-size: 12px;
    font-weight: 600;
    margin-top: 6px;
  }
  .scheduled-module-group {
    margin-bottom: 12px;
  }
  .scheduled-module-header {
    background: #f3fbf6;
    border-left: 5px solid #4dbd74;
  }
  .scheduled-module-button {
    align-items: center;
    color: #1f7a43;
    display: flex;
    font-weight: 700;
    justify-content: space-between;
  }
  .scheduled-module-button:hover,
  .scheduled-module-button:focus {
    background-color: #eaf6ef;
    color: #155f32;
    text-decoration: none;
  }
  .scheduled-module-group .card {
    border: 1px solid #d6f0df;
    border-radius: 4px;
    box-shadow: none;
  }
  .scheduled-executed-item,
  .scheduled-executed-item:hover,
  .scheduled-executed-item:focus {
    background-color: #fff !important;
    color: #2f353a !important;
  }
  .scheduled-executed-item:hover .scheduled-task-item,
  .scheduled-executed-item:focus .scheduled-task-item {
    background-color: #eef7f2 !important;
    border-radius: 4px;
    color: #2f353a !important;
  }
  .scheduled-executed-item:hover .scheduled-task-title,
  .scheduled-executed-item:focus .scheduled-task-title {
    color: #155f32 !important;
  }
  .scheduled-executed-item:hover .scheduled-task-meta,
  .scheduled-executed-item:focus .scheduled-task-meta {
    color: #536c79 !important;
  }
  .scheduled-warning-summary {
    align-items: center;
    background: #fff8e1;
    border: 1px solid #ffe08a;
    border-left: 4px solid #f0ad4e;
    border-radius: 4px;
    color: #7a5600;
    display: flex;
    gap: 10px;
    padding: 10px;
  }
  .scheduled-warning-summary-count {
    align-items: center;
    background: #f0ad4e;
    border-radius: 4px;
    color: #fff;
    display: flex;
    flex: 0 0 38px;
    font-size: 18px;
    font-weight: 700;
    height: 38px;
    justify-content: center;
  }
  .scheduled-maintenance-actions {
    border-top: 1px solid #e4e7ea;
    margin-top: 12px;
    padding-top: 10px;
    text-align: right;
  }
  .scheduled-group-actions {
    margin-top: 8px;
    text-align: right;
  }
  .scheduled-accordion-label {
    flex: 1 1 auto;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
  .scheduled-accordion-main {
    align-items: flex-start;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    width: 100%;
  }
  .scheduled-accordion-title {
    display: block;
    line-height: 1.2;
  }
  .scheduled-accordion-subtitle {
    color: #7f1d1d;
    display: block;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 3px;
  }
  .scheduled-accordion-badge {
    flex: 0 1 96px;
    line-height: 1.15;
    max-width: 96px;
    padding-left: 4px;
    padding-right: 4px;
    text-align: center;
    white-space: normal;
  }
  .scheduled-accordion-totals {
    align-items: center;
    border-radius: 4px;
    display: flex;
    font-size: 12px;
    font-weight: 700;
    gap: 6px;
    justify-content: space-between;
    margin-top: 8px;
    padding: 5px 8px;
    width: 100%;
  }
  .scheduled-accordion-totals span {
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
  }
  .scheduled-accordion-totals-danger {
    background: #f4e4e4;
    color: #7a1515;
  }
  .scheduled-accordion-summary {
    color: #7a1515;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    margin-top: 6px;
    text-align: right;
    width: 100%;
  }
  .scheduled-accordion-icon {
    color: #9b1c1c;
    flex: 0 0 12px;
    font-size: 11px;
    margin-left: 2px;
  }
  .scheduled-error-group {
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    box-shadow: none;
    max-width: 100%;
  }
  .scheduled-error-header {
    background: #fff5f5;
    border-left: 5px solid #f86c6b;
  }
  .scheduled-error-button {
    align-items: stretch;
    color: #9b1c1c;
    display: flex;
    flex-direction: column;
    font-weight: 700;
    gap: 4px;
    justify-content: flex-start;
    min-width: 0;
  }
  .scheduled-error-button:hover,
  .scheduled-error-button:focus {
    background-color: #f7e9e9;
    color: #7a1515;
    text-decoration: none;
  }
  .scheduled-sales-sync-staff-group {
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    box-shadow: none;
    max-width: 100%;
  }
  .scheduled-sales-sync-staff-header {
    background: #fff5f5;
    border-left: 5px solid #f86c6b;
  }
  .scheduled-sales-sync-staff-button {
    align-items: stretch;
    color: #9b1c1c;
    display: flex;
    flex-direction: column;
    font-weight: 700;
    gap: 4px;
    justify-content: flex-start;
    min-width: 0;
  }
  .scheduled-sales-sync-staff-button:hover,
  .scheduled-sales-sync-staff-button:focus {
    background-color: #f7e9e9;
    color: #7a1515;
    text-decoration: none;
  }
  .scheduled-sales-sync-error-item {
    background: #fff !important;
    border-color: #f1d4d4 !important;
    color: #2f353a;
    padding: 10px;
  }
  .scheduled-sales-sync-error-item .scheduled-task-title {
    color: #2f353a;
    font-size: 13px;
  }
  .scheduled-sales-sync-error-item .scheduled-task-meta {
    color: #6c757d;
  }
  .scheduled-sales-sync-error-item .scheduled-task-stats {
    align-items: stretch;
    background: #f4f6f8;
    color: #536c79;
  }
  .scheduled-sales-sync-error-item .scheduled-task-stats span {
    background: #fff;
    border-radius: 3px;
    line-height: 1.2;
    padding: 2px 3px;
    text-align: center;
  }
</style>
